import React, { useState } from 'react';
import { 
  Layout, 
  Tabs, 
  Typography, 
  Row, 
  Col, 
  Card, 
  Button,
  Space,
  Statistic,
  Progress
} from 'antd';
import { 
  MailOutlined, 
  RobotOutlined, 
  BarChartOutlined,
  PlusOutlined,
  SendOutlined,
  EyeOutlined,
  ClickOutlined,
  LinkOutlined
} from '@ant-design/icons';
import { Header } from '../../components/common/layout';
import { EmailCampaignManager, EmailAutomation, EmailAnalytics } from '../../components/features/email';

const { Content } = Layout;
const { Title, Paragraph } = Typography;
const { TabPane } = Tabs;

const EmailMarketingPage = () => {
  const [activeTab, setActiveTab] = useState('campaigns');

  const tabItems = [
    {
      key: 'campaigns',
      label: (
        <span>
          <MailOutlined />
          Campaigns
        </span>
      ),
      children: <EmailCampaignManager />
    },
    {
      key: 'automation',
      label: (
        <span>
          <RobotOutlined />
          Automation
        </span>
      ),
      children: <EmailAutomation />
    },
    {
      key: 'analytics',
      label: (
        <span>
          <BarChartOutlined />
          Analytics
        </span>
      ),
      children: <EmailAnalytics />
    }
  ];

  return (
    <>
      <Header />
      <Layout style={{ minHeight: '100vh', paddingTop: '80px' }}>
      <Content style={{ padding: '24px' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          {/* Header */}
          <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
            <Title level={1}>Email Marketing</Title>
            <Paragraph style={{ fontSize: '1.2rem', color: '#666' }}>
              Build relationships and drive engagement with targeted email campaigns
            </Paragraph>
          </div>

          {/* Quick Stats */}
          <Row gutter={[16, 16]} style={{ marginBottom: '2rem' }}>
            <Col xs={24} sm={8}>
              <Card>
                <div style={{ textAlign: 'center' }}>
                  <Title level={2} style={{ margin: 0, color: '#1890ff' }}>
                    1,247
                  </Title>
                  <div style={{ margin: '0.5rem 0' }}>
                    <MailOutlined style={{ color: '#1890ff', fontSize: '1.2rem' }} />
                  </div>
                  <Paragraph type="secondary" style={{ margin: 0 }}>
                    Total Subscribers
                  </Paragraph>
                </div>
              </Card>
            </Col>
            <Col xs={24} sm={8}>
              <Card>
                <div style={{ textAlign: 'center' }}>
                  <Title level={2} style={{ margin: 0, color: '#52c41a' }}>
                    24.8%
                  </Title>
                  <div style={{ margin: '0.5rem 0' }}>
                    <EyeOutlined style={{ color: '#52c41a', fontSize: '1.2rem' }} />
                  </div>
                  <Paragraph type="secondary" style={{ margin: 0 }}>
                    Average Open Rate
                  </Paragraph>
                </div>
              </Card>
            </Col>
            <Col xs={24} sm={8}>
              <Card>
                <div style={{ textAlign: 'center' }}>
                  <Title level={2} style={{ margin: 0, color: '#faad14' }}>
                    3.2%
                  </Title>
                  <div style={{ margin: '0.5rem 0' }}>
                    <LinkOutlined style={{ color: '#faad14', fontSize: '1.2rem' }} />
                  </div>
                  <Paragraph type="secondary" style={{ margin: 0 }}>
                    Average Click Rate
                  </Paragraph>
                </div>
              </Card>
            </Col>
          </Row>

          {/* Performance Overview */}
          <Card style={{ marginBottom: '2rem' }}>
            <Title level={4} style={{ marginBottom: '1rem' }}>
              Performance Overview
            </Title>
            <Row gutter={[16, 16]}>
              <Col xs={24} sm={12} lg={6}>
                <Statistic
                  title="Campaigns Sent"
                  value={12}
                  prefix={<SendOutlined />}
                  valueStyle={{ color: '#1890ff' }}
                />
              </Col>
              <Col xs={24} sm={12} lg={6}>
                <Statistic
                  title="Emails Delivered"
                  value={15,420}
                  prefix={<MailOutlined />}
                  valueStyle={{ color: '#52c41a' }}
                />
              </Col>
              <Col xs={24} sm={12} lg={6}>
                <Statistic
                  title="Total Opens"
                  value={3,825}
                  prefix={<EyeOutlined />}
                  valueStyle={{ color: '#faad14' }}
                />
              </Col>
              <Col xs={24} sm={12} lg={6}>
                <Statistic
                  title="Total Clicks"
                  value={494}
                  prefix={<LinkOutlined />}
                  valueStyle={{ color: '#1890ff' }}
                />
              </Col>
            </Row>
          </Card>

          {/* Main Content */}
          <Card>
            <Tabs 
              activeKey={activeTab}
              onChange={setActiveTab}
              items={tabItems}
              size="large"
            />
          </Card>

          {/* Quick Actions */}
          <Card style={{ marginTop: '2rem', textAlign: 'center' }}>
            <Title level={3}>Quick Actions</Title>
            <Paragraph>
              Get started with email marketing in just a few clicks
            </Paragraph>
            <Space size="large">
              <Button 
                type="primary" 
                size="large"
                icon={<PlusOutlined />}
                onClick={() => setActiveTab('campaigns')}
              >
                Create Campaign
              </Button>
              <Button 
                size="large"
                icon={<RobotOutlined />}
                onClick={() => setActiveTab('automation')}
              >
                Set Up Automation
              </Button>
              <Button 
                size="large"
                icon={<BarChartOutlined />}
                onClick={() => setActiveTab('analytics')}
              >
                View Analytics
              </Button>
            </Space>
          </Card>
        </div>
      </Content>
    </Layout>
    </>
  );
};

export default EmailMarketingPage;
